/* import __COLOCATED_TEMPLATE__ from './description-field.hbs'; */
import Component from '@glimmer/component';

export default class IssuesFormDescriptionFieldComponent extends Component {
  get hasContent() {
    if (!this.args.issue) {
      return false;
    }
    return this.args.issue.body != null && this.args.issue.body != '';
  }

  get showLabel() {
    if (typeof this.args.showLabel !== 'undefined') {
      return this.args.showLabel;
    }
    return true;
  }

  get placeholder() {
    if (typeof this.args.placeholder !== 'undefined') {
      return this.args.placeholder;
    }
    return 'More cowbell!';
  }
}
